<template>
    <div class="loading small">
        <i class="fa fa-refresh fa-spin"></i>
        <p>Loading</p>
    </div>
</template>

<script>
    export default {
        name: 'LoadingSmall'
    }
</script>


// WEBPACK FOOTER //
// LoadingSmall.vue?f26a0b4a